import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductCurrenciesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductCurrenciesReducer.productCurrenciesFeatureKey]
);

export const getStaticDataProductCurrenciesFailure = createSelector(
  getStaticDataProductCurrenciesState,
  staticDataCountriesReducer.fromStaticDataProductCurrenciesReducer.getProductCurrenciesFailure
);

export const getStaticDataProductCurrenciesResponse = createSelector(
  getStaticDataProductCurrenciesState,
  staticDataCountriesReducer.fromStaticDataProductCurrenciesReducer.getProductCurrenciesResponse
);

export const getStaticDataProductCurrenciesisLoaded = createSelector(
  getStaticDataProductCurrenciesState,
  staticDataCountriesReducer.fromStaticDataProductCurrenciesReducer.getProductCurrenciesIsLoaded
);
